"use-strict";
/* global $ */



import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/respimg/ls.respimg';
window.$ = window.jQuery = require('jquery');
import barba from '@barba/core';
// import Isotope from 'isotope-layout';
var imagesLoaded = require('imagesloaded');
imagesLoaded.makeJQueryPlugin($);
// require("select2-full");
// import moment from 'moment';
// require("daterangepicker");
import Swiper from 'swiper/dist/js/swiper.min.js';
// var fx = require('money');
// var accounting = require('accounting');
// import fullpage from 'fullpage.js';
// import ScrollMagic from 'ScrollMagic';
// // import 'animation.gsap';
// import 'debug.addIndicators';
// import SmoothScroll from 'smoothscroll-for-websites';
// import noUiSlider from 'nouislider';
require('malihu-custom-scrollbar-plugin-concat');
// import hoverintent from 'hoverintent';
// import localForage from "localforage";
// import 'parsleyjs';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
import anime from 'animejs';
// import Warp from 'warpjs';

var Common = {
    lastScrollPos: 0,
    $container: null,
    // pageTransition: Barba.BaseTransition.extend({
    //     start: function() {
    //         Promise
    //             .all([this.newContainerLoading, this.fadeOut()])
    //             .then(this.fadeIn.bind(this));
    //     },
    //     fadeOut: function() {
    //         var deferred = Barba.Utils.deferred();

    //         $("html").removeClass("first-page");

    //         $("#transition-animation").css({
    //             display: 'block'
    //         });
    //         anime({
    //             targets: "#transition-animation .layer-1",
    //             translateY: ['-100%', 0],
    //             easing: 'easeOutCubic',
    //             duration: 300,
    //             complete: function(){
    //                 deferred.resolve();
    //             }
    //         });
    //         return deferred.promise;
    //     },
    //     fadeIn: function() {
    //         window.scrollTo(0, 0);
    //         var _this = this;

    //         _this.done();
    //     }
    // }),
    pageTransitionLeave: function(){

    },
    pageTransitionEnter: function(){
        anime({
            targets: "#transition-animation .layer-1",
            translateY: '100%',
            easing: 'easeOutCubic',
            duration: 500,
            complete: function(){
                $("#transition-animation").css({
                    display: 'none'
                });
            }
        });
        
    },
    detectDevice: function(){
        if(!('ontouchstart' in window)){
            $('html').addClass('desktop').removeClass('mobile');
        }
    },
    scrollEvent: function(){
        let scrollpos = window.scrollY;
        const header_height = document.querySelector("header").offsetHeight;

        window.addEventListener('scroll', function() { 
            scrollpos = window.scrollY;
            if (scrollpos >= 1) { 
                document.querySelector("html").classList.add("scrolled");
            }
            else if(scrollpos === 0){
                document.querySelector("html").classList.remove("scrolled");
            }
        })
    },
    throttle: function(a,b){var c,d;return function(){var e=this,f=arguments,g=+new Date;c&&g<c+a?(clearTimeout(d),d=setTimeout(function(){c=g,b.apply(e,f)},a)):(c=g,b.apply(e,f))}},
    imagesZoom: function(e){
        e.preventDefault();
        var $this = $(e.currentTarget);
        var $wrapper = $this.closest('#main');
        var $image = $wrapper.find('.ps-image');
        var index = $wrapper.find('.ps-image').index($this);
        var items = [];
        

        $image.each(function(){
            let src = $(this).attr("src");
            var caption = $(this).siblings('.caption').html();

            items.push({
                src: src,
                w: $(this)[0].naturalWidth,
                h: $(this)[0].naturalHeight,
                msrc: src,
                title: caption ? caption : null
            });
        });
        var $pswp = $('.pswp')[0];
        var options = {
                index: index,
                bgOpacity: 0.8,
                // showHideOpacity: true,
                // showAnimationDuration: 2000,
                history: false,
                // fullscreenEl: true,
                shareEl: false,
                counterEl: false,
                // closeOnScroll: false,
                scaleMode: 'fit',
                getThumbBoundsFn: function(i) {
                    var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
                    var rect = $image[i].getBoundingClientRect();
                    return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
                }
        }
        var ps = new PhotoSwipe($pswp, PhotoSwipeUI_Default, items, options);
        ps.init();
    },
    fitMain: function($container){
        var windowHeight = $(window).height();
        var headerHeight = $container.find('header').outerHeight();
        var footerHeight = $container.find('footer').outerHeight();
        var $main = $container.find('#main');


        if($main.hasClass('ie-special')){
            
        }else if(window.matchMedia('(max-width: 1024px)').matches && $main.hasClass('mobile-full')){
            $main.css({
                "min-height": windowHeight
            });
            if(Common.isIE()) {
                $main.css({
                    "height": windowHeight
                });
            }
        }else if($main.hasClass('show-header') && $main.hasClass('show-footer')){
            $main.height(windowHeight - headerHeight - footerHeight);
        }else if($main.hasClass('desktop-fixed')){
            $main.css({
                "height": windowHeight - 37
            });
        }else if($main.hasClass('show-header')){
            $main.css({
                "min-height": windowHeight - 37
            });
            if (Common.isIE()){
                $main.css({
                    "height": windowHeight - 37
                });
            }
        }else if($main.hasClass('internal-footer')){
            $main.height(windowHeight - headerHeight);
        }else{
            $main.height(windowHeight);
        }
        
    },
    getParameterByName: function(name) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
        var results = regex.exec(window.location.href);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    isIE: function(){
        var ua = window.navigator.userAgent;
        var isIE = /MSIE|Trident/.test(ua) || window.document.documentMode;
        return isIE;
    },
    mobileShare: function(e){
        e.preventDefault();
        var url = $(e.currentTarget).data("href");
        if (navigator.share) {
          navigator.share({
              url: url
          });
        }else{
            var message = $(e.currentTarget).data("message");
            var dummy = document.createElement('input');
            document.body.appendChild(dummy);
            dummy.value = url;
            dummy.select();
            document.execCommand('copy');
            document.body.removeChild(dummy);
            alert(message);
            
        }
    },
}

$(function(){
    Common.detectDevice();
    Common.scrollEvent();
});

barba.hooks.beforeEnter((data) => {
    var $container = $(data.next.container);
    var themeColor = $container.find('#main').data('color');

    window.scrollTo(0, 0);


    $container.find('#menu .close').on('click', function(){
        $container.find('#menu-toggle input').prop("checked", false);
    });

    $('#landing-disclaimer .close').on('click', function(){
        $('#landing-disclaimer').addClass('closing');
        setTimeout(function(){
            $('#landing-disclaimer').addClass('closed');
        }, 1000);
    });

    $('#landing-language .close').on('click', function(){
        $('#landing-language').addClass('closing');
        setTimeout(function(){
            $('#landing-language').addClass('closed');
        }, 1000);
    });

    // if(themeColor){
    //     $('header').css({"background-color": themeColor});
    //     $('footer').css({"background-color": themeColor});
    // }else{
    //     $('header').css({"background-color": "#6cf"});
    //     $('footer').css({"background-color": "#6cf"});
    // }

    $container.find('.ps-image').on("click touch", Common.imagesZoom);

    $container.find('.disclaimer-open').on('click', function(){
        $(this).toggleClass('active');
        if (window.matchMedia('(max-width:1024px)').matches === true){
            $container.find('.mobile-disclaimer-box').addClass('active');
            var height = $container.find('.mobile-disclaimer-box').height();
            // $container.find('.mobile-disclaimer-box').find(".disclaimer-content-wrapper").height(height);
        }
    });

    $container.find('.mobile-disclaimer-box button.close').on('click', function(){
        $(this).closest('.mobile-disclaimer-box').removeClass('active');
        $container.find('.disclaimer-open').removeClass('active');
    });

    $container.find('.mobile-share').on('click', function(e){
        Common.mobileShare(e);
    });

    $(window).on('resize orientationchange', function(){
        Common.fitMain($container);
        $("#landing-language").height($(window).height());
    }).trigger('resize');

    // $container.find('#menu-wrapper .close').on('click', function(){
    //     $container.find('#menu-wrapper input').prop("checked", false);
    // });

    // $container.find('#menu .have-sub > button').on('click', function(){
    //     var $this = $(this);
    //     var isActive = $this.closest('.have-sub').hasClass('active');
    //     if(isActive){
    //         $container.find('.main-category').removeClass('show-sub');
    //         $this.closest('.have-sub').removeClass('active');
    //         $container.find('#menu').removeClass('active');
    //     }else{
    //         $container.find('.main-category').addClass('show-sub');
    //         $container.find('#menu').addClass('active');
    //         setTimeout(function(){
    //             $this.closest('.have-sub').addClass('active');
    //         }, 500);
    //     }
        
    // });

    // $container.find('.open-document').on('click', function(){
    //     var target = $(this).data('id');
    //     $('.document-item').removeClass('active');
    //     $('.document-item[data-id="'+target+'"]').addClass('active');
    //     if(window.matchMedia('(max-width: 767px)').matches){
    //         $container.find('#menu-wrapper input').prop("checked", false);
    //     }
    // });

    // $container.find('.document-item .close').on('click', function(){
    //     $container.find('.document-item').removeClass('active');
    // });
});
barba.hooks.beforeLeave((data) => {
    $('html').removeClass('landing');
});

barba.init({
    timeout: 5000,
    views: [{
        namespace: 'home',
        beforeEnter(data) {
            var $container = $(data.next.container);
            

            $(window).on('resize.home orientationchange.home', function(){
                $container.find('.mobile-nav li a').each(function(){
                    $(this).height($(window).height()*0.09);
                });

                // $container.find('.background').each(function(){
                //     $(this).height($(this).height());
                // });
            }).trigger('resize');

            $container.find('.open-sub-menu').on('click', function(){
                var $submenu = $(this).siblings('ul');
                var totalHeight = 0;
                $submenu.children('li').each(function(){
                    totalHeight = totalHeight + $(this).outerHeight(true);
                });
                
                var $this = $(this);
                $this.toggleClass('opened');
                if($this.hasClass('opened')){
                    $submenu.height(totalHeight);
                    const scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement;
                    if($(window).scrollTop() < $(window).height() - $this.offset().top +  totalHeight + 5){
                        anime({
                            targets: scrollElement,
                            scrollTop: $(window).height() - $this.offset().top +  totalHeight + 5,
                            duration: 500,
                            easing: 'easeInOutQuad'
                        });
                    }
                    
                }else{
                    $submenu.height(0);
                }
            });
        },
        afterEnter(data) {
           
        },
        beforeLeave(){
            $(window).off('resize.home orientationchange.home');
        }
    },
    {
        namespace: 'page-content',
        beforeEnter(data) {
            var $container = $(data.next.container);

        }
    },
    {
        namespace: 'page-download',
        beforeEnter(data) {
           var $container = $(data.next.container);

        }
    },
    {
        namespace: 'page-floorplan',
        beforeEnter(data) {
            var $container = $(data.next.container);
            $container.find('.floor-button button').on('click', function(){
                var $this = $(this);
                var floor = $this.data('floor');
                $this.siblings('.active').removeClass('active');
                $this.addClass('active');

                $container.find('.detail-wrapper .detail').removeClass('active');
                $container.find('.detail-wrapper .detail[data-floor="'+floor+'"]').addClass('active');

                $container.find('.floor-wrapper .floor').removeClass('active');
                $container.find('.floor-wrapper .floor[data-floor="'+floor+'"]').addClass('active');
            });
        }
    },
    {
        namespace: 'page-gallery',
        test: null,
        beforeEnter(data) {
            var $container = $(data.next.container);
            var swiper;
            var sectionName = Common.getParameterByName('section');
            var $section = $container.find('.section.'+sectionName);

            $section.addClass('active');
            if (window.matchMedia('(max-width:1024px)').matches === true){
                if ( swiper !== undefined ) swiper.destroy( true, true );
                $container.find("h1").text($section.find("h3").text());
            }else{
                swiper = new Swiper ($container.find('.swiper-container.section-wrapper')[0], {
                    slidesPerView: 1,
                    speed: 1500,
                    direction: 'vertical',
                    simulateTouch: false,
                    pagination: {
                          el: $container.find('.swiper-pagination')[0],
                          clickable: true
                    },
                    // mousewheel: {
                    //     // invert: true,
                    // },
                    autoHeight: true,
                    // breakpoints: {
                    //     1024: {
                    //         autoHeight: false
                    //     }
                    // },
                    on: {
                        init: function(){
                            var swiper = this;

                            setTimeout(function(){
                                $container.find(".content-wrapper").addClass('show');
                            }, 1000);
                            
                            $container.find('.nav-button').on("click", function(){
                                var index = parseInt($(this).data('to')) - 1;
                                swiper.slideTo(index);
                            });
                        }
                    }
                });
            }

            var mainSliderVideos = new Swiper ($container.find('.videos .swiper-container.main')[0], {
                slidesPerView: 1,
                simulateTouch: false,
                // effect: 'fade', // bug
                navigation: {
                    nextEl: $container.find('.videos .swiper-button-next')[0],
                    prevEl: $container.find('.videos .swiper-button-prev')[0],
                },
                on: {
                    init: function(){
                        var id = $(this.slides).data('id');
                        if(id){
                            $container.find(".section.videos .disclaimer-open").show();
                            $container.find(".section.videos .disclaimer-item[data-id='"+id+"']").addClass('active');
                            $container.find(".mobile-disclaimer-box .disclaimer-item[data-id='"+id+"']").addClass('active');
                        }else{
                            $container.find(".section.videos .disclaimer-open").hide();
                        }
                        $(window).trigger("resize");
                    },
                    slideChangeTransitionStart: function(){
                        var activeIndex = this.activeIndex;
                        var id = $(this.slides).eq(activeIndex).data('id');
                        if(id){
                            $container.find(".section.videos .disclaimer-open").show();
                            $(subSliderPhotos.slides).removeClass('is-selected');
                            $(subSliderPhotos.slides).eq(activeIndex).addClass('is-selected');
                            subSliderPhotos.slideTo(activeIndex,300, false);

                            $container.find(".section.videos .disclaimer-item").removeClass('active');
                            $container.find(".section.videos .disclaimer-item[data-id='"+id+"']").addClass('active');

                            $container.find(".mobile-disclaimer-box .disclaimer-item").removeClass('active');
                            $container.find(".mobile-disclaimer-box .disclaimer-item[data-id='"+id+"']").addClass('active');
                            // $container.find(".mobile-disclaimer-box .disclaimer-content-wrapper").height($container.find(".mobile-disclaimer-box .disclaimer-content").height());
                        }else{
                            $container.find(".section.videos .disclaimer-open").hide();
                        }
                        
                    }
                }
            });

            var subSliderVideos = new Swiper ($container.find('.videos .swiper-container.sub')[0], {
                slidesPerView: 8,
                freeMode: true,
                slideToClickedSlide: true,
                touchRatio: 0.2,
                centeredSlides: false,
                on: {
                    init: function () {
                        var $wrapper = $(this.wrapperEl);
                        var childrenCount = this.slides.length;
                        if(childrenCount < this.passedParams.slidesPerView) $wrapper.addClass('center');

                        $(this.slides).eq(0).addClass('is-selected');
                        $(window).trigger("resize");
                    },
                    tap: function(){
                        var clicked = this.clickedIndex;
                        $(this.slides).removeClass('is-selected');
                        $(this.clickedSlide).addClass('is-selected');
                        mainSliderVideos.slideTo(clicked,300, false);
                        mainSliderVideos.slideTo(clicked,300, function(){
                            mainSliderVideos.emit('slideChangeTransitionStart');
                        });
                    }
                },
                breakpoints: {
                    1300: {
                        slidesPerView: 6
                    }
                }
            });

            var mainSliderPhotos = new Swiper ($container.find('.photos .swiper-container.main')[0], {
                slidesPerView: 1,
                simulateTouch: false,
                // effect: 'fade', // bug
                navigation: {
                    nextEl:$container.find('.photos .swiper-button-next')[0],
                    prevEl:$container.find('.photos .swiper-button-prev')[0],
                },
                on: {
                    init: function(){
                        var id = $(this.slides).data('id');
                        if(id){
                            $container.find(".section.photos .disclaimer-open").show();
                            $container.find(".section.photos .disclaimer-item[data-id='"+id+"']").addClass('active');
                            $container.find(".mobile-disclaimer-box .disclaimer-item[data-id='"+id+"']").addClass('active');
                        }else{
                            $container.find(".section.photos .disclaimer-open").hide();
                        }
                        $(window).trigger("resize");
                    },
                    slideChangeTransitionStart: function(){
                        var activeIndex = this.activeIndex;
                        var id = $(this.slides).eq(activeIndex).data('id');
                        if(id){
                            $container.find(".section.photos .disclaimer-open").show();
                            $(subSliderPhotos.slides).removeClass('is-selected');
                            $(subSliderPhotos.slides).eq(activeIndex).addClass('is-selected');
                            subSliderPhotos.slideTo(activeIndex,300, false);

                            $container.find(".section.photos .disclaimer-item").removeClass('active');
                            $container.find(".section.photos .disclaimer-item[data-id='"+id+"']").addClass('active');

                            $container.find(".mobile-disclaimer-box .disclaimer-item").removeClass('active');
                            $container.find(".mobile-disclaimer-box .disclaimer-item[data-id='"+id+"']").addClass('active');
                            // $container.find(".mobile-disclaimer-box .disclaimer-content-wrapper").height($container.find(".mobile-disclaimer-box .disclaimer-content").height());
                        }else{
                            $container.find(".section.photos .disclaimer-open").hide();
                        }
                        
                    }
                }
            });

            var subSliderPhotos = new Swiper ($container.find('.photos .swiper-container.sub')[0], {
                slidesPerView: 8,
                freeMode: true,
                slideToClickedSlide: true,
                touchRatio: 0.2,
                centeredSlides: false,
                on: {
                    init: function () {
                        var $wrapper = $(this.wrapperEl);
                        var childrenCount = this.slides.length;
                        if(childrenCount < this.passedParams.slidesPerView) $wrapper.addClass('center');

                        $(this.slides).eq(0).addClass('is-selected');
                        $(window).trigger("resize");
                    },
                    tap: function(){
                        var clicked = this.clickedIndex;
                        $(this.slides).removeClass('is-selected');
                        $(this.clickedSlide).addClass('is-selected');
                        mainSliderPhotos.slideTo(clicked,300, function(){
                            mainSliderPhotos.emit('slideChangeTransitionStart');
                        });
                        
                    }
                },
                breakpoints: {
                    1300: {
                        slidesPerView: 6
                    }
                }
            });

            $container.find('.popup-open').on('click', function(e){
                if(window.matchMedia('(max-width: 1024px)').matches){
                    var $content = $(e.currentTarget).siblings('.scrollable-popup-content');
                    var video = $content.find('video')[0];
                    video.play();
                }else{
                    var $content = $(e.currentTarget).siblings('.scrollable-popup-content');
                    var popup = new ScrollablePopup();
                    popup.open($content);
                    
                    if(popup.$popup.find('.content').width() / popup.$popup.find('.content').height() > 1.777777777777777){
                        popup.$popup.find('.content').css({
                            width: Math.floor(popup.$popup.find('.content').height() * 1.777777777777777),
                            margin: '30px auto'
                        });
                    }else{
                        const height = Math.ceil(popup.$popup.find('.content').width() / 1.777777777777777);
                        popup.$popup.find('.content').css({
                            height: height,
                            margin: ($(window).height() - height)/2 + 'px 60px'
                        });
                    }

                    var video = popup.$popup.find('video')[0];
                    video.currentTime = 0;
                    video.play();

                    video.addEventListener('ended', function(){
                        popup.close();
                    }, false);

                    popup.once('close', function(){
                        video.pause();
                    });
                }
            });

            $(window).on("resize.gallery orientationchange.gallery", function(){
                $container.find('.swiper-slide').each(function(){
                    
                    if($(this).find('.middle').length){
                        var container_height = $(this).height();
                        var header_height = $(this).find("h3").length ? $(this).find("h3").height() : 0;
                        var bottom_height = $(this).find(".bottom").length ? $(this).find(".bottom").height() : 0;
                        var fill_height = container_height - header_height - bottom_height;
                        $(this).find('.middle').height(fill_height);
                    }
                    
                });
            }).trigger("resize");
        },
        beforeLeave(){
            $(window).off('resize.gallery orientationchange.gallery');
        }
    }],
    transitions: [{
        name: 'default-transition',
        leave() {
          // create your stunning leave animation here
        },
        enter() {
          // create your amazing enter animation here
        }
    }]
});


class ScrollablePopup {
    constructor() {
        this.top = 0;
        this.$parent = null;
        this.$content = null;
        this.markup = "<div class='scrollable-popup'><div class='overlay close'></div><div class='content'><button type='button' class='close'></button></div></div>";
        this.$popup = null;
        this.eventQueue = {};
        if(!Common.popupInstances) Common.popupInstances = [];
        Common.popupInstances.push(this);
    }

    open($element, popupClass){
        var _this = this;
        _this.$parent = $element.parent();
        _this.$content = $element;
        _this.$container = Common.popupInstances.length > 1 ? Common.popupInstances[Common.popupInstances.length - 2].$popup : $element.closest('main');
        // if(Common.popupInstances.length > 0) _this.$container = Common.popupInstances[Common.popupInstances.length - 1].$popup;
        _this.top = $(document).scrollTop();
        _this.$container.css({
            position: "fixed",
            top: -_this.top,
            overflow: "hidden",
            width: '100%'
        });
        // $(".sticky").css({
        //  position: "fixed",
        //  top: 0
        // });
        _this.$popup = $(_this.markup).clone();
        _this.$popup.addClass(popupClass);
        _this.$popup.find('.content').append($element);

        $("body").append(_this.$popup);
        $(document).scrollTop(0);

        anime.timeline({
            easing: 'easeOutCubic'
        }).add({
            targets: _this.$popup[0],
            opacity: [0,1],
            duration: 200
        }).add({
            targets: _this.$popup.find('.content')[0],
            opacity: [0,1],
            translateY: [40, 0],
            duration: 500
        });

        _this.$popup.find('.close').on('click touch',function(){
            _this.close();
        });
    }

    close(goTop){
        if($(".scrollable-popup").length){
            var _this = this;
            var top = goTop ? 0 : this.top;
            anime({
                targets: this.$popup[0],
                opacity: 0,
                easing: 'easeOutCubic',
                duration: 200,
                complete: function(){
                    _this.$parent.append(_this.$content);
                    _this.$popup.remove();
                    _this.$container.css({
                        position: "relative",
                        top: "auto",
                        overflow: ""
                    });
                    // $(".sticky").css({
                    //  position: "sticky",
                    //  top: "auto"
                    // });
                    $(document).scrollTop(top);
                    _this.destroy();
                    _this.trigger('close');
                }
            });
        }
    }

    once(event, callback){
        if(!this.eventQueue[event])
            this.eventQueue[event] = [];
        this.eventQueue[event].push(callback);
    }

    trigger(event, params){
        if(this.eventQueue[event]) {
            for(var i in this.eventQueue[event])
                this.eventQueue[event][i](params);
        }
    }

    destroy(){
        var i = Common.popupInstances.indexOf(this);
        Common.popupInstances.splice(i, 1);
        delete this;
    }
}
